import React from 'react';
import _ from 'lodash';
import {
  isNotUndefinedAll,
  isArrayAll,
  isFunctionAll,
} from '../../../utilities/parts';

import SelectDateBlock from '../SelectDateBlock';
import AttachDocument from '../../forms/AttachDocument';
import {
  CcusTranscriptionFormBlock,
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../../CommonFormComponents';
import { CcusBlockComponent, CcusTitleBlock } from '../../CcusFormComponent';
import { Description } from '../../Description';
import LicenseRegisterBlock from '../LicenseRegisterBlock';

/**
 * 作業員編集 画面 > 受講表彰履歴
 */
const TrainingCommendationForm = ({
  events,
  formValues,
  messages,
  disabledAll,
  comboBoxList,
  attachDocumentCodes_Attendance,
  attachDocuments_Attendance,
  ccusDescription,
}) => {
  if (
    !isNotUndefinedAll(events, formValues, messages, disabledAll, comboBoxList)
  ) {
    throw new Error('TrainingCommendationForm.jsx function call');
  }
  if (!isArrayAll(attachDocumentCodes_Attendance, attachDocuments_Attendance)) {
    throw new Error('TrainingCommendationForm.jsx function call');
  }
  if (
    !isFunctionAll(
      events.setCCUSValuesTrain,
      events.addNewTrainingBlock,
      events.inputValueSearch,
      events.deleteValue,
      events.setJobValues,
      events.uploadFile,
      events.download,
      events.deleteFile,
      events.calculationExpiredDate
    )
  ) {
    throw new Error('WorkerSafetyBasicInfoForm.jsx function call');
  }

  const getCcusBlockElement = (formValues, name) => {
    const result = [];
    _.map(formValues[`ccus_${name}`], value => {
      switch (name) {
        case 'worker_trainings':
          result.push(`${value.training_name} : ${value.training_take_date}`);
          break;
        case 'worker_special_trainings':
          result.push(
            `${value.specal_training_name} : ${value.specal_training_take_date}`
          );
          break;
        case 'worker_safety_trainings':
          result.push(
            `${value.safety_training_name} : ${value.safety_training_take_date}`
          );
          break;
        case 'worker_commendations':
          result.push(
            `${value.commendation_name} : ${value.commendation_date}`
          );
          break;
      }
    });
    return result;
  };

  const TitleElement = ({ title, name, noMarginTop }) => {
    const showCcusComponent =
      !disabledAll && name && _.size(formValues[`ccus_${name}`]) !== 0;
    return (
      <React.Fragment>
        <FormListSubHeader
          title={title}
          ccusComponent={
            showCcusComponent && (
              <CcusTitleBlock
                onClick={e => {
                  e.preventDefault();
                  events.showCcusInfoTranscriptionAgreementDialog(name);
                }}
              />
            )
          }
          noMarginTop={noMarginTop}
        />
        {showCcusComponent && (
          <CcusTranscriptionFormBlock
            ccusComponent={
              <CcusBlockComponent
                components={getCcusBlockElement(formValues, name)}
              />
            }
          />
        )}
      </React.Fragment>
    );
  };

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
      {ccusDescription}
      <FormList>
        {!disabledAll && (
          <div
            style={{
              maxWidth: '960px',
              marginBottom: '24px',
            }}
          >
            <Description type='primary'>
              「労務安全基本情報」タブ内の教育欄と「職種・免許・資格」タブにも関連した入力項目があります。
            </Description>
          </div>
        )}
        <TitleElement
          title='技能講習受講履歴'
          name='worker_trainings'
          noMarginTop={true}
        />
        <SelectDateBlock
          safetyDocItem={true}
          targetValues={formValues.worker_trainings}
          comboBoxList={comboBoxList.workerTrainings}
          keyParams={{
            searchKey: 'training_name',
            codeKey: 'training_code',
            targetKey: 'worker_trainings',
            blockKey: 'trainingCommendation',
            dateKey: 'training_take_date',
          }}
          labelName='技能講習名称'
          labelDate='受講年月日'
          events={events}
          disabledAll={disabledAll}
          messages={_.get(messages, 'trainingCommendation.worker_trainings')}
          attachDocumentParams={{
            documentCodes: attachDocumentCodes_Attendance,
            itemName: '',
            indexId: '技能講習受講履歴',
            labelDocument: '受講証明書',
            keyName: 'worker_trainings',
          }}
        />

        {!disabledAll && (
          <FormListItem className='form-list__item form-list__item--btn'>
            <button
              className='btn--sub'
              onClick={() => {
                events.addNewTrainingBlock('worker_trainings', {
                  id: null,
                  training_code: '0',
                  training_name: '',
                  worker_documents: [],
                });
              }}
            >
              追加する
            </button>
          </FormListItem>
        )}

        <TitleElement
          title='特別教育受講履歴'
          name='worker_special_trainings'
        />
        <SelectDateBlock
          safetyDocItem={true}
          targetValues={formValues.worker_special_trainings}
          comboBoxList={comboBoxList.workerSpecialTrainings}
          keyParams={{
            searchKey: 'specal_training_name',
            codeKey: 'specal_training_code',
            targetKey: 'worker_special_trainings',
            blockKey: 'trainingCommendation',
            dateKey: 'specal_training_take_date',
          }}
          labelName='特別教育名称'
          labelDate='受講年月日'
          events={events}
          disabledAll={disabledAll}
          messages={_.get(
            messages,
            'trainingCommendation.worker_special_trainings'
          )}
          attachDocumentParams={{
            documentCodes: attachDocumentCodes_Attendance,
            itemName: '',
            indexId: '特別教育受講履歴',
            labelDocument: '受講証明書',
            keyName: 'worker_special_trainings',
          }}
        />

        {!disabledAll && (
          <FormListItem className='form-list__item form-list__item--btn'>
            <button
              className='btn--sub'
              onClick={() => {
                events.addNewTrainingBlock('worker_special_trainings', {
                  id: null,
                  specal_training_code: '0',
                  specal_training_name: '',
                  worker_documents: [],
                });
              }}
            >
              追加する
            </button>
          </FormListItem>
        )}

        <TitleElement
          title='安全衛生教育受講履歴'
          name='worker_safety_trainings'
        />
        <LicenseRegisterBlock
          valueArray={formValues.worker_safety_trainings}
          keyObject={{
            searchKey: 'safety_training_name',
            codeKey: 'safety_training_code',
            targetKey: 'worker_safety_trainings',
            takeDateKey: 'safety_training_take_date',
            expireDateKey: 'safety_training_expire_date',
          }}
          comboBoxObject={{
            isShow: true,
            comboBoxList: comboBoxList.workerSafetyTrainings,
            comboBoxTitle: '安全衛生講習名称',
          }}
          takeDateObject={{
            isShow: true,
            takeDateTitle: '受講年月日',
          }}
          expireDateObject={{
            isShow: true,
            expireDateTitle: '有効期限年月日',
          }}
          validPeriodObject={{
            isShow: true,
            validPeriodTitle: '有効期間',
          }}
          attachDocumentObject={{
            isShow: true,
            documentCodes: attachDocumentCodes_Attendance,
            itemName: '',
            indexId: '安全衛生教育受講履歴',
            labelDocument: '受講証明書',
            keyName: 'worker_safety_trainings',
          }}
          messageArray={_.get(
            messages,
            'trainingCommendation.worker_safety_trainings'
          )}
          disabled={disabledAll}
          safetyDocItem={true}
          events={events}
        />

        {!disabledAll && (
          <FormListItem className='form-list__item form-list__item--btn'>
            <button
              className='btn--sub'
              onClick={() => {
                events.addNewTrainingBlock('worker_safety_trainings', {
                  id: null,
                  safety_training_code: '0',
                  safety_training_name: '',
                  safety_training_take_date: null,
                  safety_training_expire_date: null,
                  worker_documents: [],
                  validPeriodObject: {},
                  showExpireDate: true,
                  warningMessage: null,
                });
              }}
            >
              追加する
            </button>
          </FormListItem>
        )}

        <TitleElement title='表彰履歴' name='worker_commendations' />
        <SelectDateBlock
          targetValues={formValues.worker_commendations}
          comboBoxList={comboBoxList.workerCommendations}
          keyParams={{
            searchKey: 'commendation_name',
            codeKey: 'commendation_code',
            targetKey: 'worker_commendations',
            blockKey: 'trainingCommendation',
            dateKey: 'commendation_date',
          }}
          labelName='表彰名'
          labelDate='表彰年月日'
          events={events}
          disabledAll={disabledAll}
          messages={_.get(
            messages,
            'trainingCommendation.worker_commendations'
          )}
          attachDocumentParams={{
            documentCodes: attachDocumentCodes_Attendance.map(obj =>
              obj.file_typeS_name === '受講証明書'
                ? Object.assign(_.cloneDeep(obj), { file_typeS_name: '証明書' })
                : obj
            ),
            itemName: '',
            indexId: '表彰履歴',
            labelDocument: '証明書',
            keyName: 'worker_commendations',
          }}
        />

        {!disabledAll && (
          <FormListItem className='form-list__item form-list__item--btn'>
            <button
              className='btn--sub'
              onClick={() => {
                events.addNewTrainingBlock('worker_commendations', {
                  id: null,
                  commendation_code: '0',
                  commendation_name: '',
                  worker_documents: [],
                });
              }}
            >
              追加する
            </button>
          </FormListItem>
        )}

        <TitleElement title='添付書類' />
        <div className='form-list-default__ExceptionalItems'>
          <Description type='primary'>
            <React.Fragment>
              2021年12月19日以降本項目への添付書類の新規登録が行えなくなりました。
              <br />
              現在は受講表彰履歴ごとにファイルの添付が可能です。
              <br />
              すでに本項に登録済みのファイルについては、個別に添付しなおしてください。
              <br />
              本項目は将来的に廃止を予定しているため、早めにファイルの再添付をお願いいたします。
            </React.Fragment>
          </Description>
        </div>
        <FormListItem label='受講証明書'>
          <FormElement>
            <AttachDocument
              companyDocuments={attachDocuments_Attendance}
              documentCodes={attachDocumentCodes_Attendance}
              events={events}
              readOnly={disabledAll}
              deleteOnly={true}
              isFormListDefault={true}
            />
          </FormElement>
        </FormListItem>
      </FormList>
    </div>
  );
};

export default TrainingCommendationForm;



// WEBPACK FOOTER //
// ./src/components/worker/form/TrainingCommendationForm.jsx